import React from 'react';
import WebLayout from '../layouts/WebLayout';
import { Link } from 'react-router-dom';

const IntroPage = () => {
    return (
        <WebLayout>
            <div className="min-h-screen bg-white">
                {/* 히어로 섹션 */}
                <div className="bg-amber-400 text-white overflow-hidden">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 relative">
                        <div className="flex flex-col md:flex-row items-center justify-between">
                            {/* 캐릭터 이미지 */}
                            <div className="w-full md:w-1/2 flex justify-center md:justify-end relative mb-8 md:mb-0">
                                <img 
                                    src="/images/bapfriend_character03.png" 
                                    alt="밥친구 캐릭터" 
                                    className="w-64 md:w-96 h-auto object-contain transform md:-translate-x-8 animate-float"
                                />
                            </div>
                            
                            {/* 텍스트 섹션 */}
                            <div className="w-full md:w-1/2 text-center md:text-left md:pl-8">
                                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
                                    혼밥이 싫을 때,<br/>
                                    <span className="text-white drop-shadow-2xl">밥친구</span>
                                </h1>
                                <p className="text-lg md:text-xl font-medium mb-8 text-amber-50 max-w-xl leading-relaxed">
                                    새로운 사람들과 함께하는 따뜻한 식사,<br/>
                                    밥친구에서 시작하세요
                                </p>
                                <Link to="/download">
                                    <div className="inline-block px-8 py-4 bg-white text-amber-600 rounded-full font-bold text-lg hover:bg-amber-50 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-transform">
                                        지금 바로 시작하기
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

                    {/* 1행 - 밥친구 소개 */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">밥친구는</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                "누구랑 밥 먹지?" 하는 순간<br/>
                                당신 곁에 다가오는 작은 연결이예요.<br/>
                                이름도 몰랐던 사람들과,<br/>
                                맛있는 한 끼를 나누며<br/>
                                마음도 나눌 수 있는 그런 공간입니다.
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img 
                                src="/images/web1_1.png" 
                                alt="밥친구 소개 이미지" 
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* 2행 - 중앙 제목 */}
                    <div className="text-center mb-20">
                        <h2 className="text-3xl font-bold text-amber-500">왜 밥친구가 필요할까요?</h2>
                    </div>

                    {/* 3행 - 혼밥 해결 */}
                    <div className="grid md:grid-cols-2 gap-12 mb-20">
                        <div className="space-y-8">
                            <div>
                                <h3 className="text-2xl font-bold text-amber-500 mb-4">외로운 혼밥도</h3>
                                <p className="text-lg text-gray-700 leading-relaxed">
                                    "같이 밥 한 끼 먹자"는 말은 가장<br/>
                                    자연스럽고 가벼운 만남의 시작이에요.<br/>
                                    혼밥의 고립감은 줄이고, 부담 없이 누군가와 연결돼요.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-8">
                            <div>
                                <h3 className="text-2xl font-bold text-amber-500 mb-4">혼자선 먹기 힘든 음식도</h3>
                                <p className="text-lg text-gray-700 leading-relaxed">
                                    2인 이상 메뉴, 피자, 고기, 정식 요리…<br/>
                                    혼자선 먹기 어려운 음식도<br/>
                                    밥친구라면 편하게 즐길 수 있어요.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 4행 - 중앙 제목 */}
                    <div className="text-center mb-20">
                        <h2 className="text-3xl font-bold text-amber-500">장소만 정하면, 사람과 혜택은 따라와요</h2>
                    </div>

                    {/* 5행 - 위치 기반 매칭 */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h3 className="text-2xl font-bold text-amber-500">위치 기반 매칭</h3>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                밥친구는 내가 원하는 식당과 시간대만 고르면<br/>
                                근처에서 밥 함께 먹을 사람을 연결해줘요
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img 
                                src="/images/web1_2.png" 
                                alt="위치 기반 매칭 이미지" 
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* 6행 - 제휴 매장 */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h3 className="text-2xl font-bold text-amber-500">제휴 매장</h3>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                밥친구와 제휴된 매장에서<br/>
                                할인, 무료 음료, 특별 메뉴 같은<br/>
                                밥친구 전용 혜택을 누려보세요!
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img 
                                src="/images/web1_3.png" 
                                alt="제휴 매장 이미지" 
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </WebLayout>
    );
};

export default IntroPage; 